import api from './api'

export async function getLoggedAdminInfo() {
  const res = await api.get('admin/me')
  if (res.status === 200) {
    return res.data
  } else {
    return false
  }
}

export async function createAdmin(data) {
  const res = await api.post('admin', data)
  if (res.status === 201) {
    return res.data
  }
}

export async function findAdminByPhone(data) {
  try {
    const res = await api.get('admin/doc/' + data)
    if (res.status === 200) {
      return res.data
    }
  } catch (e) {
    return e
  }
}

export async function getAdminById(id) {
  const res = await api.get(`admin/${id}`)
  return res.data
}

export async function updateAdmin(data, adminId) {
  const res = await api.put(`admin/${adminId}`, data)
  if (res.status === 200) {
    return res.data
  }
}

export async function importAdmin(adminId, roles) {
  const res = await api.post(`admin/import`, { id: adminId, roles })
  if (res.status === 200) {
    return res.data
  }
}

export async function deleteAdminById(id) {
  const user = await api.delete('admin/' + id)
  return user.data
}
